'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'heart';
var width = 512;
var height = 512;
var aliases = [128153,128154,128155,128156,128420,129293,129294,129505,9829,10084,61578];
var unicode = 'f004';
var svgPathData = ['M48 165.1c0 33.3 15 64.6 32.5 92.2 21.3 33.7 50.6 67.1 81.2 97.2 30.4 30 61 55.6 84 73.8 3.6 2.9 7.1 5.5 10.3 8 3.2-2.5 6.6-5.1 10.3-8 23.1-18.2 53.6-43.8 84-73.8 30.6-30.1 59.8-63.6 81.2-97.3 17.5-27.6 32.6-58.8 32.6-92.2 0-47-38.1-85.1-85.1-85.1-27.3 0-53 13.1-69 35.2l-53.9 74.5-53.9-74.5c-16-22.1-41.7-35.2-69-35.2-47 0-85.1 38.1-85.1 85.1z', 'M256 496S0 319.4 0 167.7C0 94.2 58.6 32 133.1 32 167.7 32 200.5 45.4 225 68.8 237.1 80.3 246.3 94.4 256 107.9 265.7 94.4 274.9 80.3 287 68.8 311.5 45.4 344.4 32 378.9 32 453.5 32 512 94.2 512 167.7 512 319.4 256 496 256 496zm0-306.2l-53.9-74.5c-16-22.1-41.7-35.2-69-35.2-47 0-85.1 38.1-85.1 85.1 0 33.3 15 64.6 32.5 92.2 21.3 33.7 50.6 67.1 81.2 97.2 30.4 30 61 55.6 84 73.8 3.6 2.9 7.1 5.5 10.3 8 3.2-2.5 6.6-5.1 10.3-8 23.1-18.2 53.6-43.8 84-73.8 30.6-30.1 59.8-63.6 81.2-97.3 17.5-27.6 32.6-58.8 32.6-92.2 0-47-38.1-85.1-85.1-85.1-27.3 0-53 13.1-69 35.2L256 189.8z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHeart = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;